export default __webpack_public_path__ + "static/media/event_item2.7c6be692.png";